module.exports = __webpack_public_path__ + "media/images/features/4/dress-1-7c112d9f77ac37313f43eb547c6f0009.jpg";